import { cleanCategoryName } from '@/base/MaUtils.js'

const ALERT_ACTION_TYPES = [
  {
    name: 'Change',
    callsign: 'CHANGE',
  },
  {
    name: 'Increase',
    callsign: 'INCREASE',
  },
  {
    name: 'Decrease',
    callsign: 'DECREASE',
  },
  {
    name: 'Spike',
    callsign: 'SPIKE',
  },
  {
    name: 'Plummet',
    callsign: 'PLUMMET',
  },
  {
    name: 'Report',
    callsign: 'REPORT',
  },
  {
    name: 'First Time',
    callsign: 'FIRST_TIME',
  },
]

export default {
  get(alertType) {
    if (alertType === 'NEW_REVIEWS') {
      return ALERT_ACTION_TYPES.filter(act => !['PLUMMET', 'FIRST_TIME'].includes(act.callsign))
    }
    if (alertType === 'CURRENT_VERSION_REVIEWS') {
      return ALERT_ACTION_TYPES.filter(act => ['CHANGE', 'INCREASE', 'DECREASE'].includes(act.callsign))
    }
    if (alertType === 'USER_KEYWORDS') {
      return ALERT_ACTION_TYPES.filter(act => ['CHANGE', 'INCREASE', 'DECREASE'].includes(act.callsign))
    }
    if (alertType === 'CATEGORY_RANKING') {
      return ALERT_ACTION_TYPES.filter(act => !['REPORT'].includes(act.callsign))
    }
    return ALERT_ACTION_TYPES
  },
  hasAmount(actionType) {
    return ['CHANGE', 'INCREASE', 'DECREASE'].includes(actionType)
  },
  phrase(alertType, actionType) {
    if (alertType === 'CATEGORY_RANKING') {
      return ' in'
    }
    if (alertType === 'USER_KEYWORDS') {
      return `${cleanCategoryName(alertType)} ${
        actionType === 'CHANGE'
          ? 'changed amount of '
          : (actionType === 'INCREASE' ? 'entered the top ' : 'dropped from the top ')}`
    }
    if (['CHANGE', 'INCREASE', 'DECREASE', 'SPIKE', 'PLUMMET'].includes(actionType)) {
      return 'in the amount of'
    }
    if (['REPORT'].includes(actionType)) {
      return 'of the'
    }
    return ''
  },
  valueOf(callsign) {
    return ALERT_ACTION_TYPES.find(act => act.callsign === callsign)
  },
}
